import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-all-reports',
  templateUrl: './all-reports.component.html',
  styleUrls: ['./all-reports.component.css']
})
export class AllReportsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
